import React from "react";
export default function EditIcon(){
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 19H6.414L15.728 9.68599L14.314 8.27199L5 17.586V19ZM21 21H3V16.757L16.435 3.32199C16.6225 3.13452 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13452 17.849 3.32199L20.678 6.15099C20.8655 6.33852 20.9708 6.59283 20.9708 6.85799C20.9708 7.12316 20.8655 7.37746 20.678 7.56499L9.243 19H21V21ZM15.728 6.85799L17.142 8.27199L18.556 6.85799L17.142 5.44399L15.728 6.85799Z" fill="#555555"/>
    </svg>
}
